// Health Products Data
export const healthProducts = [
  {
    id: 201,
    name: 'Multivitamin Complex',
    brand: 'Centrum',
    price: 19.99,
    originalPrice: 29.99,
    discount: 33,
    rating: 4.8,
    reviewCount: 156,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    isGlobal: true,
  },
  {
    id: 202,
    name: 'Omega-3 Fish Oil',
    brand: 'Nature Made',
    price: 24.99,
    rating: 4.7,
    reviewCount: 128,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg',
  },
  {
    id: 203,
    name: 'Vitamin D3 + K2',
    brand: 'Garden of Life',
    price: 12.99,
    originalPrice: 18.99,
    discount: 32,
    rating: 4.9,
    reviewCount: 87,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg',
    isGlobal: true,
  },
  {
    id: 204,
    name: 'Magnesium Citrate',
    brand: 'NOW Foods',
    price: 14.99,
    originalPrice: 21.99,
    discount: 32,
    rating: 4.6,
    reviewCount: 92,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png',
  },
  {
    id: 205,
    name: 'Zinc + Vitamin C',
    brand: 'Solgar',
    price: 11.99,
    originalPrice: 17.99,
    discount: 33,
    rating: 4.7,
    reviewCount: 76,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg',
  },
  {
    id: 206,
    name: 'Probiotics Complex',
    brand: 'Culturelle',
    price: 22.99,
    originalPrice: 34.99,
    discount: 34,
    rating: 4.8,
    reviewCount: 104,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
    isGlobal: true,
  },
]
// Baby Products Data
export const babyProducts = [
  {
    id: 301,
    name: 'Baby Formula Stage 1',
    brand: 'Similac',
    price: 24.99,
    originalPrice: 32.99,
    discount: 24,
    rating: 4.9,
    reviewCount: 187,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg',
  },
  {
    id: 302,
    name: 'Baby Cereal - Rice',
    brand: 'Gerber',
    price: 8.99,
    originalPrice: 12.99,
    discount: 31,
    rating: 4.7,
    reviewCount: 93,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/2/1/213099.jpg',
  },
  {
    id: 303,
    name: 'Organic Baby Food Pouches',
    brand: 'Plum Organics',
    price: 3.99,
    originalPrice: 5.99,
    discount: 33,
    rating: 4.8,
    reviewCount: 126,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/1/0/1030868_1.png',
  },
  {
    id: 304,
    name: 'Baby Vitamin D Drops',
    brand: 'Enfamil',
    price: 13.99,
    originalPrice: 18.99,
    discount: 26,
    rating: 4.9,
    reviewCount: 78,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/1/0/1000157_1.jpg',
  },
  {
    id: 305,
    name: 'Baby DHA Supplement',
    brand: 'Nordic Naturals',
    price: 15.99,
    originalPrice: 22.99,
    discount: 30,
    rating: 4.6,
    reviewCount: 64,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/4/5/4537b3e3-4206-41fc-b34e-53ddce591f66_1.jpg',
  },
  {
    id: 306,
    name: 'Baby Probiotic Drops',
    brand: 'BioGaia',
    price: 19.99,
    originalPrice: 27.99,
    discount: 29,
    rating: 4.7,
    reviewCount: 82,
    image:
      'https://img.innovapharmacy.com/media/catalog/product/1/0/1015683_1.jpg',
  },
]
